export var TODAYS_OPEN_STATUS;
(function (TODAYS_OPEN_STATUS) {
    TODAYS_OPEN_STATUS["OPENING_LATER"] = "OPENING_LATER";
    TODAYS_OPEN_STATUS["OPEN_NOW"] = "OPEN_NOW";
    TODAYS_OPEN_STATUS["WAS_OPEN"] = "WAS_OPEN";
})(TODAYS_OPEN_STATUS || (TODAYS_OPEN_STATUS = {}));
export { AvailabilityState } from './AvailabilityState.js';
//# sourceMappingURL=index.js.map